<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm.import.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div>
		<h3 jhiTranslate="germplasm.import.inventory.header"></h3>
		<form name="inventoryDetailsForm" #inventoryDetailsForm="ngForm">
			<div jhiTranslate="germplasm.import.inventory.description" *ngIf="!hasAllInventoryDetails()"></div>
			<div class="row" style="margin-top: 15px;margin-bottom: 15px;">
				<div class="col">
					<div class="form-check form-check-inline">
						<input type="checkbox" class="form-check-input" name="createInventoryLots" id="createInventoryLots"
							   [(ngModel)]="createInventoryLots" [disabled]="!context.canCreateLots">
						<label class="form-check-label" for="createInventoryLots" jhiTranslate="germplasm.import.inventory.create.lots">
						</label>
					</div>
				</div>
			</div>
			<div class="mb-3 row">
				<div class="col" *ngIf="enableOptionsToComplete()">
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="option-group" id="completeAllEntries" [value]="true" [(ngModel)]="completeAllEntries" [disabled]="!createInventoryLots" (change)="optionsToCompleteChange($event)">
						<label class="form-check-label" for="completeAllEntries" jhiTranslate="germplasm.import.inventory.complete.all.entries"></label>
					</div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="option-group" id="someInventoryData" [value]="false" [(ngModel)]="completeAllEntries" [disabled]="!createInventoryLots" (change)="optionsToCompleteChange($event)">
						<label class="form-check-label" for="someInventoryData" jhiTranslate="germplasm.import.inventory.complete.entries.with.some.data"></label>
					</div>
				</div>
			</div>
			<div class="mb-3 row" style="margin-top: 15px;margin-bottom: 15px;" [class.required]="createInventoryLots">
				<label for="stockIdPrefixInput" class="col-sm-3 col-form-label fw-bold">
                    <span jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix">Stock ID Prefix</span>
                    <i class="fa fa-info-circle col-1 help-icon ms-3" data-bs-toggle="tooltip" data-bs-placement="top" ngbTooltip="{{ 'inventoryManagerApp.lot.create.field.stock.id.title' | translate }}"></i>
				</label>
				<div class="col-sm-6" *ngIf="!hasAllStockIds() else allGood">
                    <div class="input-group col-xs-12 col-md-12">
                        <input class="form-control" jhi-stockIdPrefixValidator [(ngModel)]="stockIdPrefix" id="stockIdPrefixInput" name="stockIdPrefixInput"
                               [disabled]="!createInventoryLots" [required]="createInventoryLots" #stockIdPrefixInput="ngModel"/>
                        <div class="invalid-feedback d-block" *ngIf="stockIdPrefixInput.invalid">
                            <small jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix.error"></small>
                        </div>
                    </div>
				</div>
			</div>
			<div class="mb-3 row" [class.required]="createInventoryLots">
				<label for="seedStorageLocation" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm.import.inventory.seed.storage.location"></label>
				<div class="col-sm-6" *ngIf="!hasAllLocations() else allGood">
					<jhi-locations-select [(value)]="locationSelected" [showFilterOptions]="true" [storageLocationsOnly]="true" [disabled]="!createInventoryLots"></jhi-locations-select>
				</div>
			</div>
			<div class="mb-3 row" [class.required]="createInventoryLots">
				<label for="dropdownUnits" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm.import.inventory.units"></label>
				<div class="col-sm-6" *ngIf="!hasAllUnits() else allGood">
					<select class="form-select" name="dropdownUnits" id="dropdownUnits" [(ngModel)]="unitSelected"
							[disabled]="!createInventoryLots" [required]="createInventoryLots" #dropdownUnits="ngModel" (change)="unitChanged()">
						<option *ngFor="let unit of units | async" [value]="unit.name">
							<label>{{unit.name}}</label>
						</option>
					</select>
				</div>
			</div>
			<div class="mb-3 row" [class.required]="createInventoryLots">
				<label for="depositAmount" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm.import.inventory.amount">
				</label>
				<div class="col-sm-6" *ngIf="!hasAllAmounts() else allGood">
					<div *ngIf="!isSeedAmountUndefined" class="row">
						<div class="input-group col-xs-12 col-md-12">
							<input type="number" class="form-control" name="depositAmount" id="depositAmount" [disabled]="!createInventoryLots"
								   [(ngModel)]="deposit.amount" jhi-customMinGreaterThanValidator min=0 #depositAmount="ngModel"
								   [ngClass]="{ 'is-invalid': inventoryDetailsForm.submitted && depositAmount.invalid }" [required]="createInventoryLots" />
						</div>
						<div class="mb-3 row" [hidden]="!(depositAmount.touched && depositAmount.invalid)">
							<div class="col-4"></div>
							<small class="invalid-feedback d-block" jhiTranslate="inventoryManagerApp.lot.create.field.amount.note">
								Initial amount must be higher than zero
							</small>
						</div>
					</div>
					<div *ngIf="isSeedAmountUndefined" class="row">
						<div class="input-group col-xs-12 col-md-12">
							<input type="number" class="form-control" name="undefinedDepositAmount" id="undefinedDepositAmount" [disabled]="true"
								   [(ngModel)]="deposit.amount" #undefinedDepositAmount="ngModel"/>
						</div>
					</div>
				</div>
			</div>
			<div><em style="font-weight: bold; font-size: 11px;">Note: </em><em style="font-size: 11px;" jhiTranslate="germplasm.import.inventory.undefined.note"></em></div>
			<div class="row" style="margin-top: 15px;margin-bottom: 15px;">
				<div class="col-xs-12 col-md-12">
					<div class="form-check form-check-inline">
						<input type="checkbox" class="form-check-input" name="confirmDeposit" id="confirmDeposit" [(ngModel)]="context.amountConfirmed" [disabled]="!createInventoryLots">
						<label class="form-check-label" for="confirmDeposit" jhiTranslate="germplasm.import.inventory.transaction.confirm">
						</label>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
		<span jhiTranslate="back"></span>
	</button>
	<button (click)="next()" [disabled]="!canProceed(inventoryDetailsForm)" class="btn btn-primary" data-test="importGermplasmInventoryButton">
		<span jhiTranslate="next"></span>
	</button>
</div>
<ng-template #allGood>
	<label class="col form-control-plaintext">
        <span [innerHTML]="'germplasm.import.basicDetails.success.message' | translate"></span><span class="fa fa-check text-success"></span>
	</label>
</ng-template>
